module.exports = __webpack_public_path__ + "media/images/icon-add-83bb8b7ae75c3915e2dabc124d06abbc.svg";